import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import { Paper, Button, CircularProgress } from '@material-ui/core';
import Card from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import {
    formatCreditCardNumber,
    formatExpirationDate,
    formatCVC
} from '../../utils/config/constants';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import HOCLoader from '../../components/HOC/HOCLoader';
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, injectIntl } from 'react-intl';
import { validateCreditCardForm } from '../../utils/validators/validateForm';
import DeleteAlert from '../../components/Alert/DeleteAlert';
import AddNewCard from '../../components/Booking/AddNewCard';
import { store } from '../../store';
var isMounted = false;
class SavedCards extends Component {
    constructor(props) {
        super();
        this.state = {
            number: '',
            name: '',
            expiry: '',
            cvc: '',
            issuer: '',
            focused: '',
            formData: null,
            booking: '',
            redirectBookingSuccess: false,
            loaderButton: false,
            deleteAlert: false,
            cardSelected: '',
            acceptLoadingButton: false,
            cardLoader: true,
            cardList: []
        };
    }

    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    getData() {
        if (isMounted) {
            this.props.cardListAction();
            this.props.savedCardListAction(this.onDone);
        }
    }
    onDone = (success, data) => {
        this.setState({ cardLoader: false });
        if (success && data.data.sources.data != []) {
            this.setState({ cardList: data.data.sources.data });
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    className="btn btn-primary btn-block"
                    onClick={this.addNewCard}
                >
                    <FormattedMessage id="payment.add" defaultMessage="Add" />
                </button>
            );
        }
    };

    onDoneAdding = (success, data) => {
        this.setState({ loaderButton: false });
        if (success) {
            NotificationManager.success(data.message, 'Success');
        } else {
            NotificationManager.error(data.message, 'Error');
        }
    };

    handleCallback = ({ issuer }, isValid) => {
        if (isValid) {
            this.setState({ issuer });
        }
    };

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name
        });
    };

    handleInputChange = ({ target }) => {
        if (target.name === 'number') {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === 'expiry') {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === 'cvc') {
            target.value = formatCVC(target.value);
        }
        this.setState({ [target.name]: target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const { issuer } = this.state;
        const formData = [...e.target.elements]
            .filter(d => d.name)
            .reduce((acc, d) => {
                acc[d.name] = d.value;
                return acc;
            }, {});

        this.setState({ formData });
        this.form.reset();
    };
    payViaCard = cardId => {
        this.props.payViaCard(cardId);
    };
    // onPaymentDone = (success, data) => {
    //     this.setState({ acceptLoadingButton: false });
    //     if (success) {
    //         NotificationManager.success(data.message, 'Success');
    //         this.setState({ redirectBookingSuccess: true });
    //     }
    // };

    alertDeleteCard = cardId => {
        this.setState({ deleteAlert: true, cardSelected: cardId });
    };

    handleYes = () => {
        this.setState({ deleteAlert: false });
        this.deleteCard(this.state.cardSelected);
    };
    handleNo = () => {
        this.setState({ deleteAlert: false });
    };
    closeDeleteAlert = () => {
        this.setState({ deleteAlert: false });
    };

    deleteCard = cardId => {
        this.props.deleteCardAction(
            {
                cardToken: cardId
            },
            this.onDeleteDone
        );
    };
    onDeleteDone = (success, data) => {
        if (success) {
            NotificationManager.success(data.message, 'Success');
        }
    };

    render() {
        if (this.state.redirectBookingSuccess) {
            this.props.history.push({
                pathname: `/user/booking/`
            });
        }
        if (this.props.cardList.length == 0) {
            return (
                <h6 className="my-4">
                    <FormattedMessage
                        id="payment.nocard"
                        defaultMessage="No card found"
                    />
                </h6>
            );
        }
        return (
            <div>
                <div>
                    <HOCLoader loading={this.props.cardLoader}>
                        <div className="">
                            <div className="ds-boar-title">
                                <h2>
                                    <FormattedMessage
                                        id="payment.savedcards"
                                        defaultMessage="Pay via saved cards"
                                    />
                                </h2>
                            </div>
                            <div className="row">
                                {this.props.cardList.map(card => {
                                    return (
                                        <div className="col-md-6" key={card.id}>
                                            <Card
                                                preview={true}
                                                number={
                                                    '************' + card.last4
                                                }
                                                expiry={
                                                    card.exp_month.length == 2
                                                        ? card.exp_month
                                                        : '0' +
                                                          card.exp_month +
                                                          '/' +
                                                          card.exp_year
                                                }
                                                issuer={card.brand}
                                                cvc=""
                                                placeholders={{ name: '' }}
                                            />
                                            <br />
                                            <div className="text-left save-card-btns">
                                                {this.props.isButtonLoading !=
                                                card.id ? (
                                                    <Button
                                                        color="primary"
                                                        onClick={() =>
                                                            this.payViaCard(
                                                                card.id
                                                            )
                                                        }
                                                    >
                                                        <FormattedMessage
                                                            id="payment.pay"
                                                            defaultMessage="Pay"
                                                        />
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        color="primary"
                                                        disabled
                                                    >
                                                        <FormattedMessage
                                                            id="payment.loading"
                                                            defaultMessage="Loading..."
                                                        />
                                                    </Button>
                                                )}

                                                <Button
                                                    color="default"
                                                    onClick={() =>
                                                        this.alertDeleteCard(
                                                            card.id
                                                        )
                                                    }
                                                >
                                                    <FormattedMessage
                                                        id="payment.delete"
                                                        defaultMessage="Delete"
                                                    />
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </HOCLoader>
                </div>

                <DeleteAlert
                    open={this.state.deleteAlert}
                    close={this.closeDeleteAlert}
                    handleNo={this.handleNo}
                    handleYes={this.handleYes}
                />
            </div>
        );
    }
}
const mapStateToProps = ({ bookings }) => {
    return {
        cardList: bookings.cardList.sources.data,
        cardLoader: bookings.cardLoader
    };
};
const composedComponent = compose(
    withTheme(),
    connect(mapStateToProps, actions)
);
export default composedComponent(injectIntl(withRouter(SavedCards)));



// WEBPACK FOOTER //
// ./src/components/Booking/SavedCards.jsx